<script>
	import DeleteButton from "../../../components/buttons/DeleteButton.svelte";

	export let holding;
	export let registrationToken;

	const removeTransaction = (index) => {
		holding.HoldingTransactions = holding.HoldingTransactions.filter((_, i) => i !== index);
	};
</script>

<div class="transaction-list">
	{#if holding.showFileUpload}
		<div class="form-row">
			{#if holding.documentList && holding.documentList.length}
				<div class="col">
					<p class="bold">Uploaded Documents</p>
				</div>

				{#each holding.documentList as document, i}
					<div class="form-group col-md-12">
						{document.fileName}
					</div>
				{/each}
			{:else}
				<div class="col">
					<h4>No files uploaded</h4>
				</div>
			{/if}
		</div>
	{:else if holding.HoldingTransactions && holding.HoldingTransactions.length > 0}
		<!-- Desktop table view -->
		<div class="d-none d-md-block">
			<table class="table table-sm">
				<thead>
					<tr>
						<th>Date</th>
						<th>Type</th>
						<th style="text-align: right">Shares</th>
						<th style="text-align: right">Price</th>
						<th style="text-align: right">Brkg</th>
						<th style="text-align: right">Code</th>
						<th style="text-align: right">Currency</th>
					</tr>
				</thead>
				<tbody>
					{#each holding.HoldingTransactions as transaction, i}
						<tr>
							<td>{transaction.TransactionDate || "N/A"}</td>
							<td>{transaction.TransactionType || "N/A"}</td>
							<td style="text-align: right">{transaction.NumberOfShares || "N/A"}</td>
							<td style="text-align: right">
								{!!transaction.PricePerShare
									? "$" + parseFloat(transaction.PricePerShare).toFixed(2)
									: "N/A"}
							</td>
							<td style="text-align: right">
								{!!transaction.Brokerage ? "$" + parseFloat(transaction.Brokerage).toFixed(2) : "N/A"}
							</td>
							<td style="text-align: right">{transaction.StockCode || "N/A"}</td>
							<td style="text-align: right">{transaction.Currency || "N/A"}</td>
							<td class="confirmation-hide" style="text-align: right">
								{#if holding.HoldingTransactions.length > 1}
									<DeleteButton on:delete={() => removeTransaction(i)}></DeleteButton>
								{/if}
							</td>
						</tr>
					{/each}
				</tbody>
			</table>
		</div>

		<!-- Mobile card view -->
		<div class="d-md-none">
			{#each holding.HoldingTransactions as transaction, i}
				<div class="transaction-card">
					<div class="transaction-row">
						<span class="transaction-label">Date:</span>
						<span class="transaction-value">{transaction.TransactionDate || "N/A"}</span>
					</div>
					<div class="transaction-row">
						<span class="transaction-label">Type:</span>
						<span class="transaction-value">{transaction.TransactionType || "N/A"}</span>
					</div>
					<div class="transaction-row">
						<span class="transaction-label">Shares:</span>
						<span class="transaction-value">{transaction.NumberOfShares || "N/A"}</span>
					</div>
					<div class="transaction-row">
						<span class="transaction-label">Price:</span>
						<span class="transaction-value">
							{!!transaction.PricePerShare
								? "$" + parseFloat(transaction.PricePerShare).toFixed(2)
								: "N/A"}
						</span>
					</div>
					<div class="transaction-row">
						<span class="transaction-label">Brokerage:</span>
						<span class="transaction-value">
							{!!transaction.Brokerage ? "$" + parseFloat(transaction.Brokerage).toFixed(2) : "N/A"}
						</span>
					</div>
					<div class="transaction-row">
						<span class="transaction-label">Code:</span>
						<span class="transaction-value">{transaction.StockCode || "N/A"}</span>
					</div>
					<div class="transaction-row">
						<span class="transaction-label">Currency:</span>
						<span class="transaction-value">{transaction.Currency || "N/A"}</span>
					</div>
					{#if holding.HoldingTransactions.length > 1}
						<div class="transaction-row confirmation-hide">
							<span class="transaction-label"></span>
							<span class="transaction-value">
								<DeleteButton on:delete={() => removeTransaction(i)}></DeleteButton>
							</span>
						</div>
					{/if}
				</div>
			{/each}
		</div>
	{/if}
</div>

<style>
	.transaction-list {
		margin-top: 0.6rem;
		border-top: 1px solid #eee;
		padding-top: 0.5rem;
	}

	:global(.confirmation .transaction-header) {
		grid-template-columns: repeat(5, 1fr) !important;
	}

	.transaction-card {
		border: 1px solid #e0e0e0;
		border-radius: 6px;
		padding: 0.75rem;
		margin-bottom: 0.75rem;
		background-color: #fafafa;
	}

	.transaction-row {
		display: flex;
		justify-content: space-between;
		padding: 0.3rem 0;
		border-bottom: 1px solid #f0f0f0;
	}

	.transaction-row:last-child {
		border-bottom: none;
	}

	.transaction-label {
		font-weight: 600;
		color: #555;
		flex: 0 0 auto;
		margin-right: 1rem;
	}

	.transaction-value {
		text-align: right;
		color: #333;
	}
</style>
